
    <fieldmagic-dialog
      icon="cog"
      label="Group Configuration"
      [instance]="self"
    >
      <ng-template fieldmagicDialogButtonsTmp>
        <fieldmagic-primary-button
          purpose="save"
          (click)="onSave()"
        >
        </fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <fieldmagic-number-input
          label="{{ 'cells_per_row' | translate }}"
          [(ngModel)]="promptPerColumn"
          [errors]="errors | data_get: 'prompt_per_column'"
          tooltip="Allows the prompts under this group to be displayed as column."
        >
        </fieldmagic-number-input>
        <fc-currency-input
          label="{{ 'annual_price_per_asset' | translate }}"
          [places]="4"
          [(ngModel)]="promptUnitPrice"
          [nonNegative]="true"
          [isGroup]="true"
        >
        </fc-currency-input>
      </ng-template>

    </fieldmagic-dialog>
  